(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orion-atlas-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__orionAtlasBanner) return;
  window.__orionAtlasBanner = true;
  const instances = new Set();
  const media = query => (window.matchMedia ? window.matchMedia(query) : {matches: false});
  const wide = media('(min-width: 750px)');
  const reducedData = media('(prefers-reduced-data: reduce)');
  const watch = (query, handler) => {
    if (query.addEventListener) query.addEventListener('change', handler);
    else if (query.addListener) query.addListener(handler);
  };
  const saveData = () => Boolean(navigator.connection && navigator.connection.saveData) || reducedData.matches;
  const readSources = value => {
    try {
      const list = JSON.parse(value || '[]');
      return Array.isArray(list) ? list.filter(item => item && typeof item.u === 'string' && item.u) : [];
    } catch (error) {
      return [];
    }
  };

  const create = (banner, gallery) => {
    const card = banner.querySelector('[data-orion-atlas-card]');
    const cta = banner.querySelector('[data-orion-atlas-cta]');
    if (!card || !cta) return null;
    const video = card.querySelector('[data-orion-atlas-video]');
    const sources = {wide: readSources(video && video.dataset.wide), tall: readSources(video && video.dataset.tall)};
    const observers = [];
    const isShown = () => !gallery || (gallery.dataset.filtered !== 'true' && gallery.dataset.galleryKind !== 'topper');
    let shown = isShown(), near = false, inView = false, variant = '', loaded = false;
    let blocked = false, failed = false, pending = false, disposed = false;
    const instance = {banner, gallery};

    // The owner's rule: the teaser loops also with reduced motion; only data savers keep the photograph, and (owner,
    // 2026-10-05: speed) wherever the film would not play smoothly, by the homepage's rule (layout/theme.liquid).
    const allowed = () => Boolean(video) && !failed && !saveData() && document.documentElement.getAttribute('data-orion-opening') !== 'picture';
    const wantsPlayback = () => allowed() && loaded && shown && inView && !document.hidden && !blocked;

    // The layout's own orientation first, otherwise whichever teaser exists.
    const pickVariant = () => {
      const first = wide.matches ? 'wide' : 'tall';
      const second = first === 'wide' ? 'tall' : 'wide';
      return sources[first].length ? first : sources[second].length ? second : '';
    };

    // Smallest MP4 rendition that still covers the card at up to 2x density.
    const pickSource = list => {
      const density = Math.min(window.devicePixelRatio || 1, 2);
      const width = card.clientWidth, height = card.clientHeight;
      const sorted = list.slice().sort((a, b) => (Number(a.w) || 0) - (Number(b.w) || 0));
      const enough = sorted.find(item => {
        const w = Number(item.w), h = Number(item.h);
        return w > 0 && h > 0 && w >= Math.max(width, height * w / h) * density * 0.9;
      });
      return (enough || sorted[sorted.length - 1]).u;
    };

    const load = () => {
      const next = pickVariant();
      if (!next) {
        failed = true;
        return;
      }
      if (loaded && next === variant) return;
      variant = next;
      loaded = true;
      card.dataset.videoVariant = next;
      card.classList.remove('has-film');
      video.preload = 'auto';
      video.src = pickSource(sources[next]);
    };

    const unload = () => {
      if (!loaded) return;
      loaded = false;
      variant = '';
      card.classList.remove('has-film');
      delete card.dataset.videoVariant;
      video.pause();
      video.removeAttribute('src');
      video.preload = 'none';
      try { video.load(); } catch (error) { /* An emptied element needs no further clean-up. */ }
    };

    const dispose = () => {
      if (disposed) return;
      disposed = true;
      observers.forEach(observer => observer.disconnect());
      card.removeEventListener('click', openProduct);
      document.removeEventListener('pointerdown', resume, true);
      document.removeEventListener('touchend', resume, true);
      document.removeEventListener('click', resume, true);
      document.removeEventListener('keydown', resume, true);
      if (video) video.pause();
      instances.delete(instance);
    };

    const play = () => {
      if (pending || !video.paused) return;
      pending = true;
      let attempt;
      try { attempt = video.play(); } catch (error) { attempt = Promise.reject(error); }
      Promise.resolve(attempt).then(() => { blocked = false; }).catch(error => {
        const name = error && error.name;
        if (name === 'NotAllowedError') blocked = true;
        else if (name !== 'AbortError') failed = true;
      }).finally(() => {
        pending = false;
        sync();
      });
    };

    function sync() {
      if (disposed) return;
      if (!banner.isConnected) {
        dispose();
        return;
      }
      if (!video) return;
      if (!allowed()) {
        unload();
        return;
      }
      // Preload once the banner is near the viewport; play only while it is actually seen.
      if (shown && (near || inView)) load();
      if (loaded) {
        if (wantsPlayback()) play();
        else if (!video.paused) video.pause();
      }
    }

    // The teaser has no pause: a browser that blocked autoplay starts it at the first touch or key.
    function resume() {
      if (!blocked) return;
      blocked = false;
      sync();
    }

    // One link only: a click on the artwork or copy forwards to the CTA.
    function openProduct(event) {
      if (window.Shopify && window.Shopify.designMode) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('a, button')) return;
      if (window.getSelection && String(window.getSelection()).trim()) return;
      cta.click();
    }
    card.addEventListener('click', openProduct);
    card.dataset.linked = '';

    // Filters and the topper view fold the banner. When it is above the viewport, fold it
    // instantly and move the scroll position by the same height, so the results stay put.
    const compensate = () => {
      const before = banner.getBoundingClientRect();
      if (before.top >= 0) return;
      const top = window.scrollY;
      banner.classList.add('is-instant');
      const after = banner.getBoundingClientRect();
      // Absolute target: a shorter document may already have clamped the scroll position.
      if (after.height !== before.height) window.scrollTo({top: Math.max(0, top + after.height - before.height), left: window.scrollX, behavior: 'instant'});
      requestAnimationFrame(() => requestAnimationFrame(() => banner.classList.remove('is-instant')));
    };
    if (gallery && 'MutationObserver' in window) {
      const flags = new MutationObserver(() => {
        const next = isShown();
        if (next === shown) return;
        shown = next;
        if (banner.isConnected) compensate();
        sync();
      });
      flags.observe(gallery, {attributes: true, attributeFilter: ['data-filtered', 'data-gallery-kind']});
      observers.push(flags);
    }

    if (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      // Black Friday opens out of the dark once, then returns to 2 s on every lap (owner, 23/10).
      const loopStart = Number(video.dataset.loopStart) || 0;
      if (loopStart > 0) {
        const loop = () => {
          if (!loaded || !Number.isFinite(video.duration) || video.duration <= loopStart) return;
          try { video.currentTime = loopStart; } catch (error) { return; }
          if (wantsPlayback()) play();
        };
        video.addEventListener('timeupdate', () => {
          if (!video.seeking && video.currentTime >= video.duration - .12) loop();
        });
        video.addEventListener('ended', loop);
      }
      video.addEventListener('play', () => { if (!wantsPlayback()) video.pause(); });
      video.addEventListener('playing', () => {
        if (!loaded) return;
        card.classList.add('has-film');
        blocked = false;
      });
      video.addEventListener('error', () => {
        if (!loaded || !video.getAttribute('src')) return;
        failed = true;
        sync();
      });
      // Safari on an iPhone counts the end of a touch or a click as the gesture that may start a film, not the
      // pointer going down.
      document.addEventListener('pointerdown', resume, true);
      document.addEventListener('touchend', resume, true);
      document.addEventListener('click', resume, true);
      document.addEventListener('keydown', resume, true);
      if ('IntersectionObserver' in window) {
        const nearby = new IntersectionObserver(entries => {
          near = entries[entries.length - 1].isIntersecting;
          sync();
        }, {rootMargin: '320px 0px'});
        const seen = new IntersectionObserver(entries => {
          inView = entries[entries.length - 1].intersectionRatio >= 0.2;
          sync();
        }, {threshold: [0, 0.2, 0.5]});
        nearby.observe(card);
        seen.observe(card);
        observers.push(nearby, seen);
      } else {
        near = true;
        inView = true;
      }
    }

    // Started inside a visitor's own tap (the pop-up opened by the NEW button): Safari, when it refuses to start a
    // film by itself, lets it start within that gesture, so the film is asked for and played there and then.
    instance.start = () => {
      if (!video || !allowed() || !shown) return;
      near = true;
      inView = true;
      blocked = false;
      load();
      play();
    };
    instance.sync = sync;
    instance.dispose = dispose;
    return instance;
  };

  const refresh = () => instances.forEach(instance => instance.sync());
  // The pop-up calls this from the NEW button's click, to start its film within that gesture.
  window.__orionAtlasStart = within => instances.forEach(instance => {
    if (within && within.contains(instance.banner) && instance.start) instance.start();
  });
  const initialize = () => {
    const orphans = [...instances].filter(instance => !instance.banner.isConnected);
    document.querySelectorAll('[data-orion-atlas-banner]').forEach(banner => {
      if (banner.dataset.atlasReady === 'true') return;
      const gallery = banner.closest('[data-orion-gallery]');
      // A catalogue switch re-renders the hero around an identical banner. Keep the live one,
      // so its photograph and teaser continue without a reload.
      const match = gallery ? orphans.findIndex(instance => instance.gallery === gallery && instance.banner.dataset.signature === banner.dataset.signature) : -1;
      if (match > -1) {
        const [orphan] = orphans.splice(match, 1);
        banner.replaceWith(orphan.banner);
        orphan.sync();
        return;
      }
      banner.dataset.atlasReady = 'true';
      const instance = create(banner, gallery);
      if (!instance) return;
      instances.add(instance);
      instance.sync();
    });
    orphans.forEach(instance => instance.dispose());
  };

  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  watch(wide, refresh);
  watch(reducedData, refresh);
  if (navigator.connection && navigator.connection.addEventListener) navigator.connection.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();

// The pop-up comes by itself only in the series catalogues (data-orion-atlas-auto): after 2.2 s of visible
// browsing, then 30 s after it is closed, then 1 min 30 s, each wait three times the last. The count runs only
// while such a catalogue is seen, with the filters and other dialogs closed. Switching catalogue or filters keeps
// it, and so does going to another page and back; a reload starts it again.
(() => {
  if (window.__orionAtlasPopup) return;
  window.__orionAtlasPopup = true;
  const FIRST = 2200, AGAIN = 30000, GROWTH = 3, GRACE = 1500, TICK = 250;
  const KEY = 'orion-atlas-popup-timer';
  const current = () => document.querySelector('[data-orion-atlas-popup]');
  // The wait after it has come by itself `times` times: 30 s, 1 min 30 s, 4 min 30 s, …
  const pause = times => AGAIN * GROWTH ** (Math.max(times, 1) - 1);
  let times = 0, left = FIRST, last = 0, stored = 0, returnFocus = null;

  const save = () => {
    try { sessionStorage.setItem(KEY, JSON.stringify({times, left: Math.round(left)})); } catch (error) { /* Private mode: this page only. */ }
  };
  try {
    const navigation = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    const state = navigation && navigation.type === 'reload' ? null : JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (state && Number.isFinite(state.times) && Number.isFinite(state.left)) {
      times = Math.max(0, Math.floor(state.times));
      left = Math.max(0, state.left);
    }
  } catch (error) { /* Start afresh. */ }

  const filtering = () => Boolean(document.querySelector('[data-filter-open="true"], [data-filter-state="open"]'));
  const counts = dialog => Boolean(dialog) && dialog.hasAttribute('data-orion-atlas-auto') && !dialog.open && !document.hidden && !filtering() && !(window.Shopify && window.Shopify.designMode);
  // Never over another dialog or the open sort menu: it waits until they close.
  const free = () => !document.querySelector('dialog[open]:not([data-orion-atlas-popup]), details.orion-sort[open]');

  // asked: the visitor pressed the "ΝΕΟ" notice. That does not count as a time it came by itself.
  const open = (dialog, asked) => {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    // Black Friday over (layout/theme.liquid): its pop-up no longer comes, even on a page from the cache.
    if (dialog.hasAttribute('data-orion-bf-live') && document.documentElement.classList.contains('orion-bf-over')) return;
    if (!asked) times += 1;
    // The next wait is set already, so a visitor who leaves through the card does not meet it again at once.
    left = pause(times);
    save();
    returnFocus = document.activeElement;
    dialog.showModal();
    // Opened by the visitor's own tap: the film starts within that gesture (Safari may refuse it a moment later).
    if (asked && window.__orionAtlasStart) window.__orionAtlasStart(dialog);
    document.documentElement.classList.add('orion-atlas-popup-open');
    // Commit the closed pose first, so the entrance transitions always run from it.
    void dialog.offsetWidth;
    dialog.classList.add('is-open');
  };

  const close = dialog => {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-open');
    // The next wait counts from the moment it closes.
    left = pause(times);
    save();
    window.setTimeout(() => {
      dialog.close();
      dialog.classList.remove('is-closing');
      document.documentElement.classList.remove('orion-atlas-popup-open');
      if (returnFocus && typeof returnFocus.focus === 'function' && returnFocus.isConnected) returnFocus.focus({preventScroll: true});
    }, 440);
  };

  window.setInterval(() => {
    const now = performance.now();
    const step = last ? Math.min(now - last, 1000) : 0;
    last = now;
    const dialog = current();
    if (!counts(dialog)) return;
    left = Math.max(0, left - step);
    if (left > 0) {
      if (now - stored > 2000) { stored = now; save(); }
      return;
    }
    if (free()) open(dialog, false);
    else left = GRACE;
  }, TICK);
  document.addEventListener('visibilitychange', () => { if (document.hidden) save(); });
  window.addEventListener('pagehide', save);

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target && target.closest('[data-orion-atlas-open]')) {
      event.preventDefault();
      if (!document.querySelector('dialog[open]:not([data-orion-atlas-popup])')) open(current(), true);
      return;
    }
    const trigger = target ? target.closest('[data-orion-atlas-close]') : null;
    const dialog = trigger ? trigger.closest('[data-orion-atlas-popup]') : null;
    if (dialog) close(dialog);
  });
  document.addEventListener('cancel', event => {
    if (!event.target.matches || !event.target.matches('[data-orion-atlas-popup]')) return;
    event.preventDefault();
    close(event.target);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-collection-ajax"] && !Shopify.designMode) return;
  try {
    (() => {
const FEEL_KEY='filter.p.m.custom.hardness';
const FEEL_VALUES=['0.0,0.5,1.0,1.5,2.0,2.5,3.0,3.5,4.0','4.5','5.0,5.5','6.0,6.5','7.0,7.5,8.0,8.5,9.0,9.5,10.0'];
const feelGroup=value=>{const n=Number(value);return value===null||value===undefined||String(value).trim()===''||!Number.isFinite(n)||n<0||n>10?-1:n<=4?0:n<5?1:n<6?2:n<7?3:4;};
const selectedFeelGroups=params=>[...new Set(params.getAll(FEEL_KEY).flatMap(v=>v.split(',')).filter(v=>v.trim()!=='').map(feelGroup).filter(v=>v>=0))].sort((a,b)=>a-b);
const normalizeFeel=params=>{const groups=selectedFeelGroups(params);params.delete(FEEL_KEY);groups.flatMap(i=>FEEL_VALUES[i].split(',')).forEach(value=>params.append(FEEL_KEY,value));return params;};
const RECOMMENDATION_SECTION='orion-collection-recommendation-candidates';
const RECOMMENDATION_MAX_PAGES=8;
function rankRecommendations(candidates,params,source){
  const unique=[...new Map(candidates.filter(c=>c.kind===source.kind&&c.collection===source.handle&&Number.isFinite(c.price)&&c.price>=0).map(c=>[String(c.id),c])).values()];
  const normalize=v=>String(v??'').trim().toLocaleLowerCase();
  const values=v=>(Array.isArray(v)?v:[v]).flatMap(x=>String(x??'').split(',')).map(normalize).filter(Boolean);
  const constraints=[...new Set([...params.keys()].filter(k=>k.startsWith('filter.')&&!k.startsWith('filter.v.price.')))];
  const low=Number(params.get('filter.v.price.gte')||0), high=params.has('filter.v.price.lte')?Number(params.get('filter.v.price.lte')):Infinity;
  const groups=selectedFeelGroups(params);
  const distanceToGroup=n=>Math.min(...groups.map(g=>g===0?Math.max(0,n-4):g===1?Math.abs(n-4.5):g===2?Math.max(0,5-n,n-5.5):g===3?Math.max(0,6-n,n-6.5):Math.max(0,7-n)));
  const scored=unique.map(c=>{
    let missing=0;
    for(const key of constraints){
      const wanted=params.getAll(key).flatMap(values);
      const actual=values(c.facets?.[key]);
      const matches=key===FEEL_KEY?groups.includes(feelGroup(c.hardness)):wanted.some(v=>actual.includes(v));
      if(!matches)missing+=1;
    }
    const firmnessDistance=groups.length?(c.hardness===null||c.hardness===''||!Number.isFinite(Number(c.hardness))?11:distanceToGroup(Number(c.hardness))):0;
    return {...c,missing,firmnessDistance,priceGap:Math.max(0,low-c.price,c.price-high)};
  });
  const byPrice=[...scored].sort((a,b)=>a.price-b.price||String(a.id).localeCompare(String(b.id)));
  const split=Math.max(1,Math.floor(byPrice.length/2));
  const compare=(a,b)=>a.missing-b.missing||a.firmnessDistance-b.firmnessDistance||a.priceGap-b.priceGap;
  const economical=byPrice.slice(0,split).sort((a,b)=>compare(a,b)||a.price-b.price)[0];
  const higher=byPrice.slice(split).sort((a,b)=>compare(a,b)||b.price-a.price).slice(0,2);
  const picked=[economical,...higher].filter(Boolean);
  for(const c of [...scored].sort((a,b)=>compare(a,b)||a.price-b.price))if(picked.length<3&&!picked.some(p=>p.id===c.id))picked.push(c);
  return picked.slice(0,3);
}

  const initialize=()=>document.querySelectorAll('[data-orion-gallery]').forEach(root=>{
    if(root.dataset.ajaxReady) return;
    root.dataset.ajaxReady='true';
    root.dataset.ajaxSession=String(Date.now());
    root.dataset.ajaxUpdates='0';
    const panel=root.querySelector('[data-orion-filter-sheet]');
    if(!panel) return;
    const feedback=root.querySelector('[data-collection-feedback]');
    const message=feedback.querySelector('[data-collection-message]');
    const retry=feedback.querySelector('[data-collection-retry]');
    // The series, and the baby mattresses, which have a film of their own like a series (but no pill).
    const families=['armonia','smart','comfort','filoxenia','infants'];
    // The series being browsed. Empty on the complete mattress catalogue and the toppers: no series pill is current there.
    let currentFamily=families.includes(root.dataset.gallerySource)?root.dataset.gallerySource:'';
    // "Baby Mattresses" alone on the complete catalogue is the Βρεφικά collection: that filter shows its page (and film).
    const INFANTS_KEY='filter.p.m.custom.mattress_type';
    const infantsUrl=root.dataset.infantsUrl,infantsType=root.dataset.infantsType;
    // Suggestions follow the collection being browsed (family, all mattresses or toppers), not the global filter URL.
    const recommendationSources=(()=>{try{return JSON.parse(root.querySelector('[data-recommendation-state]')?.dataset.candidateSources||'{}');}catch(error){return {};}})();
    let browseSource=recommendationSources[root.dataset.gallerySource]?root.dataset.gallerySource:'armonia';
    const familyUrl=()=>currentFamily==='infants'?infantsUrl:root.querySelector(`[data-orion-selector-family="${currentFamily}"]`)?.href;
    const globalBase=root.dataset.globalCatalogUrl;
    const globalToppers=root.dataset.globalTopperUrl;
    let activeUrl=new URL(location.href),requestId=0,requestController,facetPromise,lastRequest,noticeTimer;
    let facetKey='',facetsId=0;
    const cache=new Map();
    const countSelections=url=>{
      const others=[...url.searchParams].filter(([key,value])=>key.startsWith('filter.')&&key!==FEEL_KEY&&!key.startsWith('filter.v.price.')&&value!=='').length;
      const price=[...url.searchParams].some(([key,value])=>key.startsWith('filter.v.price.')&&value!=='')?1:0;
      return selectedFeelGroups(url.searchParams).length+others+price;
    };
    const replaceFeelChips=(next,url,group)=>{
      const selected=selectedFeelGroups(url.searchParams);
      if(!group&&selected.length){
        group=document.createElement('div');group.className='orion-collection-page__active-filters';
        next.querySelector('.orion-collection-page__layout').before(group);
      }
      if(!group)return group;
      group.querySelectorAll('a').forEach(a=>{if(a.textContent.trim().startsWith(feedback.dataset.feel+':'))a.remove();});
      selected.forEach(index=>{
        const removed=new URL(url);const remaining=selected.filter(i=>i!==index);
        removed.searchParams.delete(FEEL_KEY);
        remaining.flatMap(i=>FEEL_VALUES[i].split(',')).forEach(value=>removed.searchParams.append(FEEL_KEY,value));
        const label=next.querySelector(`[data-feel-group="${index}"]`)?.closest('li').querySelector('.orion-filter-sheet__value').textContent.trim();
        const a=document.createElement('a');a.href=removed.toString();a.dataset.activeFeelGroup=String(index);
        const text=document.createElement('span');text.textContent=feedback.dataset.feel+': '+label;a.appendChild(text);
        a.insertAdjacentHTML('beforeend','<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 4 8 8m0-8-8 8" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>');
        group.prepend(a);
      });
      if(!group.querySelector('.orion-collection-page__clear-all')){
        const clear=document.createElement('a');clear.className='orion-collection-page__clear-all';clear.textContent=feedback.dataset.clear;group.appendChild(clear);
      }
      return group;
    };
    const candidateCache=new Map(),cardCache=new Map();
    const recommendationSourcesFor=url=>{
      const toppers={handle:'toppers',kind:'topper',url:recommendationSources.toppers};
      const all={handle:'mattress',kind:'mattress',url:recommendationSources.mattress+'/mattress'};
      if(browseSource==='toppers')return [toppers];
      const topper=kindOf(url)==='topper';
      if(!families.includes(browseSource))return [topper?toppers:all];
      const family={handle:browseSource,kind:topper?'topper':'mattress',url:recommendationSources[browseSource]+(topper?'/topper':'/mattress')};
      // A family with too few matching products falls back to the complete catalogue of the same kind.
      return [family,topper?toppers:all];
    };
    const recommendationUrl=(input,page)=>{
      const url=context(new URL(input,location.origin));url.hash='';
      url.searchParams.set('section_id',RECOMMENDATION_SECTION);
      if(page>1)url.searchParams.set('page',String(page));
      return url;
    };
    const fetchRecommendationSection=async url=>{
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      let response;
      try{response=await fetch(url,{credentials:'same-origin',signal:controller.signal});}finally{clearTimeout(timer);}
      if(!response.ok)throw new Error('Recommendations unavailable');
      const container=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-recommendation-candidates]');
      if(!container)throw new Error('Recommendation catalogue missing');
      return container;
    };
    // Light ranking data only; the first page reports how many further pages to fetch in parallel.
    const loadRecommendationCandidates=source=>{
      if(!source.url||source.url.startsWith('undefined'))return Promise.reject(new Error('Recommendation source missing'));
      if(candidateCache.has(source.url))return candidateCache.get(source.url);
      const promise=(async()=>{
        const first=await fetchRecommendationSection(recommendationUrl(source.url,1));
        const pages=Math.min(Math.max(Number(first.dataset.recommendationPages)||1,1),RECOMMENDATION_MAX_PAGES);
        const rest=await Promise.all(Array.from({length:pages-1},(_,index)=>fetchRecommendationSection(recommendationUrl(source.url,index+2))));
        const candidates=[],seen=new Set();
        [first,...rest].forEach(container=>container.querySelectorAll('[data-recommendation-candidate]').forEach(template=>{
          const data=JSON.parse(template.dataset.candidate);
          if(!seen.has(data.id)){seen.add(data.id);candidates.push(data);}
        }));
        return candidates;
      })().catch(error=>{candidateCache.delete(source.url);throw error;});
      candidateCache.set(source.url,promise);
      return promise;
    };
    // Only the three chosen cards are rendered, in the browsed collection's context.
    const loadRecommendationCard=candidate=>{
      if(cardCache.has(candidate.url))return cardCache.get(candidate.url);
      const promise=fetchRecommendationSection(recommendationUrl(candidate.url,1)).then(container=>{
        const template=container.querySelector('template[data-recommendation-card]');
        if(template?.content.querySelector('[data-recommended-product]')?.dataset.recommendedProduct!==String(candidate.id))throw new Error('Recommendation card missing');
        return template;
      }).catch(error=>{cardCache.delete(candidate.url);throw error;});
      cardCache.set(candidate.url,promise);
      return promise;
    };
    const showRecommendations=async(url,version)=>{
      const box=root.querySelector('[data-orion-recommendations]');if(!box)return;
      const status=box.querySelector('[data-recommendation-status]'),retryButton=box.querySelector('[data-recommendation-retry]');
      retryButton.hidden=true;status.textContent=feedback.dataset.recommendationsLoading;
      root.dataset.recommendationsState='loading';
      const sources=recommendationSourcesFor(url);
      if(sources[0].kind==='topper'){
        const title=box.querySelector('[data-recommendation-title]'),intro=box.querySelector('[data-recommendation-intro]');
        if(title?.dataset.topperTitle)title.textContent=title.dataset.topperTitle;
        if(intro?.dataset.topperIntro)intro.textContent=intro.dataset.topperIntro;
      }
      try{
        let selected=[];
        for(const source of sources){
          const candidates=await loadRecommendationCandidates(source);
          if(version!==requestId||!box.isConnected)return;
          selected=rankRecommendations(candidates,url.searchParams,source);
          if(selected.length===3)break;
        }
        if(selected.length!==3)throw new Error('Three distinct suggestions required');
        const templates=await Promise.all(selected.map(loadRecommendationCard));
        if(version!==requestId||!box.isConnected)return;
        const grid=box.querySelector('[data-recommendation-grid]');grid.replaceChildren();
        templates.forEach(template=>{
          const card=document.importNode(template.content,true).querySelector('[data-recommended-product]');
          const image=card.querySelector('img');
          if(image){
            card.classList.add('is-gallery-loading');
            const reveal=async()=>{try{await image.decode();}catch(error){}card.classList.remove('is-gallery-loading');};
            image.addEventListener('load',reveal,{once:true});image.addEventListener('error',reveal,{once:true});
            grid.appendChild(card);if(image.complete)reveal();
          }else grid.appendChild(card);
        });
        status.textContent='';root.dataset.recommendationsState='ready';
      }catch(error){
        if(version!==requestId||!box.isConnected)return;
        box.querySelector('[data-recommendation-grid]').replaceChildren();
        status.textContent=feedback.dataset.recommendationsError;retryButton.hidden=false;root.dataset.recommendationsState='error';
        console.warn('[Orion recommendations]',error);
      }
    };
    const prepareResultPresentation=(count,next,toppers,url,version)=>{
      const results=root.querySelector('.orion-collection-page__results');
      // The next group must keep every repeated native facet value, not only the first one.
      if(toppers&&root.dataset.galleryTopperUrl){
        const topperUrl=new URL(root.dataset.galleryTopperUrl,location.origin);
        topperUrl.search=url.search;topperUrl.searchParams.delete('page');
        root.dataset.galleryTopperUrl=topperUrl.toString();
      }
      const onlyToppers=count>0&&(kindOf(url)==='topper'||Number(next.querySelector('[data-result-count]').dataset.resultCount)===0&&toppers);
      root.dataset.onlyToppers=String(Boolean(onlyToppers));
      root.dataset.recommendationsState='idle';
      if(onlyToppers){
        results.querySelector('.orion-collection-page__empty')?.remove();
        results.querySelector('[data-gallery-topper-heading]')?.remove();
        results.prepend(root.querySelector('[data-topper-result-heading]').content.cloneNode(true));
        root.querySelector('.orion-collection-page__toolbar-meta>span').textContent=`${feedback.dataset.toppers} · ${count}`;
      }
      if(count===0&&hasFilters(url)){
        results.replaceChildren(root.querySelector('[data-recommendation-state]').content.cloneNode(true));
        showRecommendations(url,version);
      }
    };
    root.addEventListener('click',event=>{if(event.target.closest('[data-recommendation-retry]'))showRecommendations(new URL(activeUrl),requestId);});

    const hasFilters=url=>[...url.searchParams].some(([key,value])=>key.startsWith('filter.')&&value!=='');
    const kindOf=url=>url.pathname===new URL(globalToppers,location.origin).pathname||url.pathname.endsWith('/topper')?'topper':url.pathname.endsWith('/mattress/mattress')||families.some(f=>url.pathname.endsWith(`/${f}/mattress`))?'mattress':'all';
    const baseFor=(kind,global)=>{
      // Outside a series (complete catalogue or toppers) the collection being browsed is the global one.
      const family=!global&&currentFamily?familyUrl():'';
      if(!family) return kind==='topper'?globalToppers:globalBase+(kind==='mattress'?'/mattress':'');
      return family+(kind==='topper'?'/topper':kind==='mattress'?'/mattress':'');
    };
    const infantsFor=url=>{
      if(!infantsUrl||!infantsType||kindOf(url)==='topper') return null;
      const filters=[...url.searchParams].filter(([key,value])=>key.startsWith('filter.')&&value!=='');
      if(filters.length!==1||filters[0][0]!==INFANTS_KEY||filters[0][1]!==infantsType) return null;
      const target=context(new URL(infantsUrl,location.origin));
      const sort=url.searchParams.get('sort_by'); if(sort) target.searchParams.set('sort_by',sort);
      return target;
    };
    const cleanUrl=input=>{
      const url=new URL(input,location.origin);
      if(url.origin!==location.origin) throw new Error('Unexpected collection origin');
      ['section_id','sections','page'].forEach(key=>url.searchParams.delete(key));
      url.hash=''; normalizeFeel(url.searchParams); return url;
    };
    const context=url=>{
      ['preview_theme_id','_fd','pb','preview_key'].forEach(key=>{
        if(activeUrl.searchParams.has(key)&&!url.searchParams.has(key)) url.searchParams.set(key,activeUrl.searchParams.get(key));
      }); return url;
    };
    const requestSection=async(url,signal)=>{
      const endpoint=context(new URL(url)); endpoint.hash=''; endpoint.searchParams.set('section_id',root.dataset.gallerySection);
      const key=endpoint.toString(),saved=cache.get(key);
      if(saved&&Date.now()-saved.time<120000) return new DOMParser().parseFromString(saved.html,'text/html').querySelector('[data-orion-gallery]');
      const response=await fetch(endpoint,{credentials:'same-origin',signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok) throw new Error(`Collection response ${response.status}`);
      const html=await response.text();
      const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-orion-gallery]');
      if(!next?.querySelector('[data-filter-form]')||!next.querySelector('.orion-collection-page__results')) throw new Error('Incomplete collection section');
      cache.set(key,{html,time:Date.now()}); if(cache.size>12) cache.delete(cache.keys().next().value);
      return next;
    };
    const requestSet=async(url,signal)=>{
      const requests=[requestSection(url,signal)];
      if(kindOf(url)==='all'&&url.pathname===new URL(globalBase,location.origin).pathname){
        const topperUrl=new URL(globalToppers,location.origin); topperUrl.search=url.search;
        requests.push(requestSection(topperUrl,signal));
      }
      const [next,toppers=null]=await Promise.all(requests);
      return {next,toppers};
    };
    // The mattress and topper catalogues are disjoint. Merge their native facet counts/options.
    const combinedForm=(next,toppers)=>{
      const form=next.querySelector('[data-filter-form]').cloneNode(true);
      if(!toppers) return form;
      const body=form.querySelector('.orion-filter-sheet__body');
      toppers.querySelectorAll('[data-facet-key]').forEach(group=>{
        const match=[...body.querySelectorAll('[data-facet-key]')].find(g=>g.dataset.facetKey===group.dataset.facetKey);
        if(!match){body.appendChild(group.cloneNode(true));return;}
        group.querySelectorAll('li:has(input[type=checkbox])').forEach(row=>{
          const input=row.querySelector('input');
          const existing=[...match.querySelectorAll('input[type=checkbox]')].find(el=>el.name===input.name&&el.value===input.value);
          if(existing){
            const count=existing.closest('li').querySelector('small');
            const total=Number(count.textContent)+Number(row.querySelector('small').textContent);
            count.textContent=String(total); existing.checked=existing.checked||input.checked; existing.disabled=total===0&&!existing.checked;
          } else {
            const added=row.cloneNode(true),addedInput=added.querySelector('input');
            addedInput.id+='-topper'; added.querySelector('label').htmlFor=addedInput.id;
            match.querySelector('ul')?.appendChild(added);
          }
        });
      });
      const firmness=form.querySelector('[data-facet-key="filter.p.m.custom.hardness"] ul');
      if(firmness) [...firmness.children].sort((a,b)=>Number(a.querySelector('input').dataset.feelGroup)-Number(b.querySelector('input').dataset.feelGroup)).forEach(row=>firmness.appendChild(row));
      const price=form.querySelector('[data-filter-price]'),other=toppers.querySelector('[data-filter-price]');
      if(price&&other) price.dataset.max=String(Math.max(Number(price.dataset.max),Number(other.dataset.max)));
      return form;
    };
    const setFacetsBusy=value=>{
      panel.dataset.facetsBusy=String(value);
      panel.querySelector('[data-filter-form]').inert=value||root.dataset.filterState!=='open';
      panel.querySelector('[data-facets-loading]').hidden=!value;
      panel.querySelector('.orion-filter-sheet__apply').disabled=value;
    };
    const installFacets=(next,toppers,url)=>{
      const old=panel.querySelector('[data-filter-form]');
      const expanded=new Map([...old.querySelectorAll('[data-facet-key]')].map(g=>[g.dataset.facetKey,g.open]));
      const offset=old.querySelector('.orion-filter-sheet__body').scrollTop;
      const fresh=combinedForm(next,toppers);
      fresh.action=url.toString();
      fresh.querySelectorAll('[data-facet-key]').forEach(g=>{if(expanded.has(g.dataset.facetKey))g.open=expanded.get(g.dataset.facetKey);});
      old.replaceWith(document.importNode(fresh,true));
      panel.dataset.activeCount=String(countSelections(url));
      panel.dataset.filterUrl=url.pathname;
      panel.querySelector('.orion-filter-sheet__body').scrollTop=offset;
      facetKey=url.pathname+'?'+url.searchParams.toString();
      setFacetsBusy(false);
      root.dispatchEvent(new CustomEvent('orion:facets-updated'));
    };
    const showNotice=(text,error=false)=>{
      clearTimeout(noticeTimer); feedback.hidden=false; message.textContent=text; retry.hidden=!error;
    };
    const loadGlobalFacets=()=>{
      const url=context(new URL(baseFor(root.dataset.galleryKind,true),location.origin)); url.search=activeUrl.search;
      if(currentFamily==='infants'&&infantsType&&!hasFilters(url)) url.searchParams.append(INFANTS_KEY,infantsType);
      const key=url.pathname+'?'+url.searchParams.toString();
      if(key===facetKey) return Promise.resolve();
      if(facetPromise) return facetPromise;
      const version=++facetsId,controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      setFacetsBusy(true);
      facetPromise=requestSet(url,controller.signal).then(({next,toppers})=>{
        if(version===facetsId) installFacets(next,toppers,url);
      }).catch(error=>{
        if(version!==facetsId) return;
        // Do not allow submitting catalogue-limited options when the global facets failed.
        panel.querySelector('[data-facets-loading]').textContent=feedback.dataset.error;
        showNotice(feedback.dataset.error,true); lastRequest={facets:true};
        console.warn('[Orion facets]',error);
      }).finally(()=>{clearTimeout(timer);facetPromise=null;});
      return facetPromise;
    };
    const syncBanner=filtered=>{
      root.dataset.filtered=String(filtered);
      root.querySelectorAll('[data-orion-selector-family]').forEach(link=>{
        const selected=!filtered&&link.dataset.orionSelectorFamily===currentFamily;
        link.classList.toggle('is-selected',selected);
        if(selected) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
      });
      root.dispatchEvent(new CustomEvent('orion:collection-banner'));
    };
    const waitForFilm=async()=>{
      const video=root.querySelector('.orion-selector__film');
      if(!video||video.readyState>=2) return;
      await new Promise(resolve=>{
        let timer;
        const done=()=>{clearTimeout(timer);video.removeEventListener('loadeddata',done);video.removeEventListener('error',done);resolve();};
        video.addEventListener('loadeddata',done,{once:true});video.addEventListener('error',done,{once:true});
        // The authentic poster remains available if a slow connection delays the film.
        timer=setTimeout(done,1400);
      });
    };
    const swapRegion=(selector,next,beforeSelector)=>{
      const old=root.querySelector(selector),fresh=next.querySelector(selector);
      if(old&&fresh) old.replaceWith(document.importNode(fresh,true));
      else if(old) old.remove();
      else if(fresh) root.querySelector(beforeSelector).before(document.importNode(fresh,true));
    };
    const combineAppliedFilters=(next,toppers,url)=>{
      const selector='.orion-collection-page__active-filters';
      let group=next.querySelector(selector);
      const extra=toppers?.querySelector(selector);
      if(extra){
        if(!group){group=extra.cloneNode(false);next.querySelector('.orion-collection-page__layout').before(group);}
        const labels=new Set([...group.querySelectorAll('a')].map(a=>a.textContent.trim()));
        extra.querySelectorAll('a:not(.orion-collection-page__clear-all)').forEach(link=>{
          if(!labels.has(link.textContent.trim())) group.prepend(link.cloneNode(true));
        });
        if(!group.querySelector('.orion-collection-page__clear-all')) group.appendChild(extra.querySelector('.orion-collection-page__clear-all').cloneNode(true));
      }
      group=replaceFeelChips(next,url,group);
      if(group){
        const clear=group.querySelector('.orion-collection-page__clear-all');
        const cleared=new URL(url); [...cleared.searchParams.keys()].filter(key=>key.startsWith('filter.')).forEach(key=>cleared.searchParams.delete(key));
        if(clear)clear.href=cleared.toString();
      }
      const count=countSelections(url);
      const opener=next.querySelector('[data-orion-filter-open]');
      let badge=opener?.querySelector('span');
      if(count&&opener){if(!badge){badge=document.createElement('span');opener.appendChild(badge);}badge.textContent=String(count);}
      else badge?.remove();
    };
    const render=async(input,options={})=>{
      let url=context(cleanUrl(input));
      const kind=options.kind||kindOf(url);
      if(options.clear){
        const sort=url.searchParams.get('sort_by')||activeUrl.searchParams.get('sort_by');
        url=context(new URL(baseFor(kind,false),location.origin)); if(sort)url.searchParams.set('sort_by',sort);
      } else if(hasFilters(url)||options.global){
        const parameters=url.search;
        url=context(new URL(baseFor(kind,hasFilters(url)),location.origin)); url.search=parameters;
      }
      url=infantsFor(url)||url;
      const version=++requestId; facetsId+=1;
      requestController?.abort(); requestController=new AbortController();
      const timer=setTimeout(()=>requestController.abort(),20000);
      const targetFiltered=hasFilters(url);
      const targetFamily=families.find(f=>url.pathname.split('/').includes(f));
      const oldFiltered=hasFilters(activeUrl);
      const oldFamily=currentFamily;
      const activeScene=root.querySelector('[data-orion-scene]')?.dataset.orionScene;
      const replaceFilm=!targetFiltered&&targetFamily&&activeScene!==targetFamily;
      const openingFilm=!targetFiltered&&(oldFiltered||replaceFilm);
      // Blackout begins immediately. Collapsing the actual banner height brings the grid up with it.
      if(targetFiltered) syncBanner(true);
      if(replaceFilm){root.dataset.bannerSwitch='true';root.dispatchEvent(new CustomEvent('orion:collection-banner'));}
      const fadeDuration=420;
      const blackout=replaceFilm?new Promise(resolve=>setTimeout(resolve,fadeDuration)):Promise.resolve();
      lastRequest={url:url.toString(),options};
      root.dataset.collectionBusy='true';
      root.querySelector('.orion-collection-page__results').setAttribute('aria-busy','true');
      showNotice(feedback.dataset.loading);
      try {
        const [{next,toppers}]=await Promise.all([requestSet(url,requestController.signal),blackout]);
        if(version!==requestId||!root.isConnected) return;
        // Keep the header and drawer mounted; catalogue navigation is also a partial update.
        const scroll=window.scrollY;
        root.dispatchEvent(new CustomEvent('orion:collection-results-before'));
        combineAppliedFilters(next,toppers,url);
        ['galleryKind','gallerySource','galleryTopperUrl','priceFloor','priceCeiling'].forEach(key=>root.dataset[key]=next.dataset[key]);
        if(!targetFiltered&&recommendationSources[root.dataset.gallerySource])browseSource=root.dataset.gallerySource;
        delete root.dataset.galleryComplete;
        swapRegion('.orion-collection-page__toolbar',next);
        swapRegion('.orion-collection-page__active-filters',next,'.orion-collection-page__layout');
        swapRegion('.orion-collection-page__kind-nav',next);
        swapRegion('.orion-collection-page__results',next);
        if(targetFamily) currentFamily=targetFamily; else if(!targetFiltered) currentFamily='';
        if(replaceFilm){
          swapRegion('.orion-collection-page__hero',next);
          root.parentElement.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
        }
        activeUrl=url;
        if(options.history!=='none') history[options.history==='replace'?'replaceState':'pushState']({...history.state,orionCollection:true,family:currentFamily,recommendationSource:browseSource},'',url.pathname+url.search);
        const count=Number(next.querySelector('[data-result-count]').dataset.resultCount)+(toppers?Number(toppers.querySelector('[data-result-count]').dataset.resultCount):0);
        root.querySelector('.orion-collection-page__catalog').dataset.resultCount=String(count);
        const countLabel=root.querySelector('.orion-collection-page__toolbar-meta>span');
        countLabel.textContent=`${count} ${feedback.dataset.results}`;
        prepareResultPresentation(count,next,toppers,url,version);
        // Preserve filters through view-all/mattress/topper links without a full navigation.
        root.querySelectorAll('[data-orion-catalog-kind]').forEach(link=>{const target=new URL(link.href);target.search=url.search;link.href=target.toString();});
        if(families.includes(root.dataset.gallerySource)){
          facetKey='';
          // Keep global options; they will be refreshed on the next opening after clearing.
          installFacets(next,null,url); facetKey='';
        } else installFacets(next,toppers,url);
        root.dispatchEvent(new CustomEvent('orion:collection-results-updated'));
        root.dataset.ajaxUpdates=String(Number(root.dataset.ajaxUpdates)+1);
        const results=root.querySelector('.orion-collection-page__results').getBoundingClientRect();
        const lastUsefulOffset=Math.max(results.top+window.scrollY,results.bottom+window.scrollY-window.innerHeight/2);
        window.scrollTo({top:Math.min(scroll,lastUsefulOffset),behavior:'instant'});
        if(openingFilm) await waitForFilm();
        if(version!==requestId) return;
        // Commit the compact/dark frame first, then expand and reveal the next catalogue together.
        root.querySelector('[data-orion-selector]')?.getBoundingClientRect();
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        if(version!==requestId) return;
        syncBanner(targetFiltered);
        root.dataset.bannerSwitch='false';
        root.dispatchEvent(new CustomEvent('orion:collection-banner'));
        showNotice(`${count} ${feedback.dataset.results}`);
        noticeTimer=setTimeout(()=>{feedback.hidden=true;},1800);
      } catch(error) {
        if(version!==requestId) return;
        currentFamily=oldFamily;root.dataset.bannerSwitch='false';syncBanner(oldFiltered);
        showNotice(feedback.dataset.error,true);
        console.warn('[Orion collection filter]',error);
      } finally {
        clearTimeout(timer);
        if(version===requestId){
          root.dataset.collectionBusy='false';
          root.querySelector('.orion-collection-page__results').setAttribute('aria-busy','false');
        }
      }
    };
    root.addEventListener('orion:facets-request',loadGlobalFacets);
    root.addEventListener('orion:collection-request',event=>render(event.detail.url,event.detail));
    retry.addEventListener('click',()=>{
      if(lastRequest?.facets){panel.querySelector('[data-facets-loading]').textContent=feedback.dataset.loading;loadGlobalFacets();}
      else if(lastRequest) render(lastRequest.url,lastRequest.options);
    });
    root.addEventListener('submit',event=>{
      if(!event.target.matches('.orion-collection-page__sort')) return;
      event.preventDefault();
      const url=new URL(activeUrl); url.searchParams.set('sort_by',event.submitter.value);
      event.target.querySelector('details').open=false;
      render(url,{kind:root.dataset.galleryKind});
    });
    root.addEventListener('click',event=>{
      const family=event.target.closest('[data-orion-selector-family]');
      if(family&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey&&event.button===0){
        event.preventDefault();
        root.dispatchEvent(new CustomEvent('orion:filter-dismiss'));
        render(family.href,{family:family.dataset.orionSelectorFamily});
        return;
      }
      const link=event.target.closest('.orion-collection-page__active-filters a, [data-orion-catalog-kind], .orion-collection-page__empty a');
      if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0) return;
      event.preventDefault();
      const isKind=link.matches('[data-orion-catalog-kind]');
      const clear=link.matches('.orion-collection-page__clear-all, .orion-collection-page__empty a');
      render(link.href,{clear,kind:isKind?kindOf(new URL(link.href)):root.dataset.galleryKind,global:!isKind});
    });
    window.addEventListener('popstate',()=>{if(root.isConnected){if(history.state?.orionCollection)currentFamily=families.includes(history.state.family)?history.state.family:'';if(recommendationSources[history.state?.recommendationSource])browseSource=history.state.recommendationSource;render(location.href,{history:'none'});}});
    syncBanner(hasFilters(activeUrl));
    // Bookmarked family-specific filters also become a global search without a document reload.
    if(hasFilters(activeUrl)) render(activeUrl,{global:true,history:'replace'});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-collection-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => document.querySelectorAll('[data-orion-filter-sheet]').forEach(panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready='true';
    const root=panel.closest('[data-orion-gallery]');
    if (!root) return;
    let form=panel.querySelector('[data-filter-form]');
    let body=panel.querySelector('.orion-filter-sheet__body');
    const opener=()=>root.querySelector('[data-orion-filter-open]');
    const close=panel.querySelector('[data-filter-dismiss]');
    const grip=panel.querySelector('[data-filter-grip]');
    const peek=grip;
    const backdrop=root.querySelector('[data-filter-backdrop]');
    let price=panel.querySelector('[data-filter-price]');
    const mobile=matchMedia('(max-width:989px)');
    const memoryKey='orion-sheet:catalogue';
    let bindingVersion=0;
    let state='closed',dirty=false,opened=false,drag=null,suppressClick=0,limitsPromise,snapFrame=0;
    let floor=0,ceiling=Number(price?.dataset.max||0),priceReady=!price;
    let numberLow=price?.querySelector('[data-price-low]');
    let numberHigh=price?.querySelector('[data-price-high]');
    let rangeLow=price?.querySelector('[data-price-low-range]');
    let rangeHigh=price?.querySelector('[data-price-high-range]');
    let minButton=price?.querySelector('[data-price-minimum]');
    let maxButton=price?.querySelector('[data-price-maximum]');
    let status=price?.querySelector('[data-price-status]');
    let money=new Intl.NumberFormat(document.documentElement.lang||'el',{style:'currency',currency:price?.dataset.currency||'EUR',maximumFractionDigits:2});
    const remember=value=>{try{sessionStorage.setItem(memoryKey,value);}catch(error){}};
    const selectedCount=()=>form.querySelectorAll('input[type=checkbox]:checked').length + (price && (Number(numberLow.value)>floor || Number(numberHigh.value)<ceiling) ? 1:0);
    const setState=(next,focus=true)=>{
      if(next==='peek' && (!mobile.matches || !selectedCount())) next='closed';
      if(snapFrame) cancelAnimationFrame(snapFrame);
      state=next;
      root.dataset.filterState=state;
      root.dataset.filterOpen=String(state==='open');
      panel.inert=state==='closed';
      form.inert=state!=='open'||panel.dataset.facetsBusy==='true';
      panel.querySelector('.orion-filter-sheet__header').inert=state!=='open';
      panel.setAttribute('role',state==='open'?'dialog':'region');
      panel.setAttribute('aria-hidden',String(state==='closed'));
      if(state==='open') panel.setAttribute('aria-modal','true'); else panel.removeAttribute('aria-modal');
      document.documentElement.classList.toggle('orion-collection-filter-open',state==='open');
      opener()?.setAttribute('aria-expanded',String(state==='open'));
      grip.setAttribute('aria-expanded',String(state==='open'));
      grip.setAttribute('aria-label',state==='open'?grip.dataset.collapseLabel:grip.dataset.reopenLabel);
      peek.querySelector('[data-filter-peek-count]').textContent=selectedCount()?String(selectedCount()):'';
      // Preserve the exact drag position until the target state has been painted.
      // Removing the override on the next frame lets CSS animate from that position.
      panel.classList.remove('is-dragging');
      root.dataset.sheetDragging='false';
      panel.getBoundingClientRect();
      snapFrame=requestAnimationFrame(()=>{panel.style.removeProperty('--sheet-offset');root.style.removeProperty('--sheet-progress');snapFrame=0;});
      if(state==='open') {
        opened=true;
        root.dispatchEvent(new CustomEvent('orion:facets-request'));
        loadLimits();
        if(focus) requestAnimationFrame(()=>close.focus({preventScroll:true}));
      } else if(focus) (state==='peek'?peek:opener())?.focus({preventScroll:true});
      remember(state);
    };
    const drawRange=()=>{
      if(!price) return;
      const low=Number(numberLow.value),high=Number(numberHigh.value),span=Math.max(.01,ceiling-floor);
      rangeLow.value=String(low); rangeHigh.value=String(high);
      price.style.setProperty('--range-low',`${(low-floor)/span*100}%`);
      price.style.setProperty('--range-high',`${(high-floor)/span*100}%`);
      rangeLow.style.zIndex=low>=ceiling? '3':'1';
      rangeHigh.style.zIndex='2';
      rangeLow.setAttribute('aria-valuetext',money.format(low));
      rangeHigh.setAttribute('aria-valuetext',money.format(high));
      minButton.querySelector('span').textContent=money.format(floor);
      maxButton.querySelector('span').textContent=money.format(ceiling);
    };
    const syncValue=(side,value,mark=true)=>{
      if(!Number.isFinite(value)) return;
      const low=Number(numberLow.value),high=Number(numberHigh.value);
      if(side==='low') numberLow.value=String(Math.round(Math.max(floor,Math.min(value,high))*100)/100);
      else numberHigh.value=String(Math.round(Math.min(ceiling,Math.max(value,low))*100)/100);
      if(mark) dirty=true;
      drawRange();
    };
    const applyLimits=bounds=>{
      floor=Math.max(0,Number(bounds.min)); ceiling=Math.max(floor,Number(bounds.max));
      [numberLow,numberHigh,rangeLow,rangeHigh].forEach(input=>{input.min=String(floor);input.max=String(ceiling);input.disabled=false;});
      numberLow.value=String(price.dataset.currentMin===''?floor:Math.max(floor,Math.min(ceiling,Number(price.dataset.currentMin))));
      numberHigh.value=String(price.dataset.currentMax===''?ceiling:Math.max(Number(numberLow.value),Math.min(ceiling,Number(price.dataset.currentMax))));
      priceReady=true; price.removeAttribute('aria-busy'); status.textContent=''; drawRange();
    };
    const fetchBounds=async(path)=>{
      const url=new URL(path,location.origin);
      url.search=''; url.hash='';
      url.searchParams.set('sort_by','price-ascending');
      url.searchParams.set('section_id',panel.dataset.sectionId);
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),10000);
      try {
        const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});
        if(!response.ok) throw new Error('Price bounds unavailable');
        const page=new DOMParser().parseFromString(await response.text(),'text/html');
        const result=page.querySelector('[data-orion-gallery][data-price-floor]');
        if(!result) throw new Error('Price bounds missing');
        const min=Number(result.dataset.priceFloor),max=Number(result.dataset.priceCeiling);
        if(!Number.isFinite(min)||!Number.isFinite(max)||max<min) throw new Error('Invalid price bounds');
        return {min,max};
      } finally {clearTimeout(timer);}
    };
    const loadLimits=()=>{
      const version=bindingVersion;
      if(!price||priceReady) return Promise.resolve();
      if(limitsPromise) return limitsPromise;
      const cacheKey='orion-global-price-limits:'+root.dataset.galleryKind+':'+price.dataset.currency;
      try {
        const cached=JSON.parse(sessionStorage.getItem(cacheKey)||'null');
        if(cached && Date.now()-cached.time<900000) {applyLimits(cached);return Promise.resolve();}
      } catch(error) {}
      price.setAttribute('aria-busy','true'); status.textContent=status.dataset.loading;
      [numberLow,numberHigh,rangeLow,rangeHigh].forEach(input=>input.disabled=true);
      const paths=[root.dataset.galleryKind==='topper'?root.dataset.globalTopperUrl:root.dataset.globalCatalogUrl];
      if(root.dataset.galleryKind==='all') paths.push(root.dataset.globalTopperUrl);
      limitsPromise=Promise.all(paths.map(fetchBounds)).then(values=>{
        const bounds={min:Math.min(...values.map(v=>v.min)),max:Math.max(...values.map(v=>v.max)),time:Date.now()};
        try {sessionStorage.setItem(cacheKey,JSON.stringify(bounds));} catch(error) {}
        if(version===bindingVersion) applyLimits(bounds);
      }).catch(()=>{
        if(version!==bindingVersion) return;
        price.removeAttribute('aria-busy'); status.textContent=status.dataset.error;
        [numberLow,numberHigh,rangeLow,rangeHigh].forEach(input=>input.disabled=false);
      }).finally(()=>{if(version===bindingVersion) limitsPromise=null;});
      return limitsPromise;
    };
    const collapse=()=>{
      setState(mobile.matches && opened && selectedCount()?'peek':'closed');
      if(mobile.matches && dirty) form.requestSubmit();
    };
    root.addEventListener('click',event=>{if(event.target.closest('[data-orion-filter-open]')) setState('open');});
    close.addEventListener('click',()=>setState('closed'));
    root.addEventListener('orion:filter-dismiss',()=>setState('closed',false));
    backdrop.addEventListener('click',collapse);
    grip.addEventListener('click',event=>{
      if(Date.now()<suppressClick){event.preventDefault();return;}
      if(state==='peek') setState('open'); else collapse();
    });
    const beginDrag=event=>{
      if(!mobile.matches||event.button!==0) return;
      if(snapFrame) cancelAnimationFrame(snapFrame);
      const height=panel.getBoundingClientRect().height;
      const travel=Math.max(1,height-48);
      const transform=getComputedStyle(panel).transform;
      const current=transform==='none'?0:new DOMMatrixReadOnly(transform).m42;
      drag={start:event.clientY,last:event.clientY,time:performance.now(),lastTime:performance.now(),velocity:0,target:event.currentTarget,pointerId:event.pointerId,origin:state,startOffset:Math.max(0,Math.min(travel,current)),offset:current,travel};
      event.currentTarget.setPointerCapture(event.pointerId);
      panel.classList.add('is-dragging');
      panel.style.setProperty('--sheet-offset',`${drag.startOffset}px`);
      root.dataset.sheetDragging='true';
      root.style.setProperty('--sheet-progress',String(1-drag.startOffset/travel));
      document.documentElement.classList.add('orion-collection-filter-open');
    };
    const moveDrag=event=>{
      if(!drag||event.pointerId!==drag.pointerId) return;
      const now=performance.now();
      drag.velocity=(event.clientY-drag.last)/Math.max(1,now-drag.lastTime);
      drag.lastTime=now;
      drag.last=event.clientY;
      drag.offset=Math.max(0,Math.min(drag.travel,drag.startOffset+drag.last-drag.start));
      panel.style.setProperty('--sheet-offset',`${drag.offset}px`);
      root.style.setProperty('--sheet-progress',String(1-drag.offset/drag.travel));
      root.dataset.sheetDragOffset=String(Math.round(drag.offset));
    };
    const endDrag=event=>{
      if(!drag) return;
      const delta=drag.last-drag.start;
      const velocity=performance.now()-drag.lastTime<100?drag.velocity:0;
      const origin=drag.origin;
      const offset=drag.offset,travel=drag.travel;
      try{drag.target.releasePointerCapture(event.pointerId);}catch(error){}
      drag=null;
      if(Math.abs(delta)<7){setState(origin,false);return;}
      suppressClick=Date.now()+500;
      const open=origin==='peek'
        ? delta < -Math.min(64,travel*.18)||velocity<-.35||offset<travel*.5
        : !(delta>Math.min(80,travel*.22)||velocity>.35||offset>travel*.5);
      if(open) setState('open'); else collapse();
    };
    const cancelDrag=()=>{if(!drag)return;const previous=drag.origin;drag=null;setState(previous,false);};
    grip.addEventListener('pointerdown',beginDrag);
    grip.addEventListener('pointermove',moveDrag);
    grip.addEventListener('pointerup',endDrag);
    grip.addEventListener('pointercancel',cancelDrag);
    window.addEventListener('resize',cancelDrag);
    panel.addEventListener('keydown',event=>{
      if(event.key==='Escape') {event.preventDefault();setState('closed');return;}
      if(event.key!=='Tab' || state!=='open') return;
      const controls=[...panel.querySelectorAll('button,a[href],input,summary')].filter(el=>!el.disabled&&el.getClientRects().length&&(el.tagName==='SUMMARY'||!el.closest('details:not([open])')));
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    });
    mobile.addEventListener('change',()=>{panel.style.removeProperty('--sheet-offset');if(state==='peek'&&!mobile.matches)setState('closed',false);});

    const bindForm=()=>{
      bindingVersion+=1; limitsPromise=null;
      form=panel.querySelector('[data-filter-form]');
      body=form.querySelector('.orion-filter-sheet__body');
      price=form.querySelector('[data-filter-price]');
      numberLow=price?.querySelector('[data-price-low]'); numberHigh=price?.querySelector('[data-price-high]');
      rangeLow=price?.querySelector('[data-price-low-range]'); rangeHigh=price?.querySelector('[data-price-high-range]');
      minButton=price?.querySelector('[data-price-minimum]'); maxButton=price?.querySelector('[data-price-maximum]');
      status=price?.querySelector('[data-price-status]');
      money=new Intl.NumberFormat(document.documentElement.lang||'el',{style:'currency',currency:price?.dataset.currency||'EUR',maximumFractionDigits:2});
      floor=0; ceiling=Number(price?.dataset.max||0); priceReady=!price;
    if(price) {
      numberLow.value=price.dataset.currentMin||'0'; numberHigh.value=price.dataset.currentMax||String(ceiling);
      drawRange();
      rangeLow.addEventListener('input',()=>syncValue('low',Number(rangeLow.value)));
      rangeHigh.addEventListener('input',()=>syncValue('high',Number(rangeHigh.value)));
      numberLow.addEventListener('change',()=>syncValue('low',numberLow.value===''?floor:Number(numberLow.value)));
      numberHigh.addEventListener('change',()=>syncValue('high',numberHigh.value===''?ceiling:Number(numberHigh.value)));
      minButton.addEventListener('click',()=>{if(!priceReady) loadLimits(); else syncValue('low',floor);});
      maxButton.addEventListener('click',()=>{if(!priceReady) loadLimits(); else syncValue('high',ceiling);});
    }
    form.addEventListener('input',()=>{dirty=true;});
    form.addEventListener('change',()=>{dirty=true;});

      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(panel.dataset.facetsBusy==='true') return;
        if(price&&!priceReady) await loadLimits();
        if(price && !priceReady) return;
        if(price){
          syncValue('low',numberLow.value===''?floor:Number(numberLow.value),false);
          syncValue('high',numberHigh.value===''?ceiling:Number(numberHigh.value),false);
        }
        const url=new URL(form.action,location.origin);
        url.search=new URLSearchParams(new FormData(form)).toString(); url.hash='';
        if(price){
          if(Number(numberLow.value)===floor) url.searchParams.delete(numberLow.name);
          if(Number(numberHigh.value)===ceiling) url.searchParams.delete(numberHigh.name);
        }
        const afterState=mobile.matches&&selectedCount()?'peek':'closed';
        setState(afterState);
        root.dispatchEvent(new CustomEvent('orion:collection-request',{detail:{url:url.toString(),afterState,global:true}}));
      });
    };
    panel.addEventListener('click',event=>{
      const clear=event.target.closest('[data-filter-clear]');
      if(!clear) return;
      event.preventDefault(); setState('closed');
      root.dispatchEvent(new CustomEvent('orion:collection-request',{detail:{url:clear.href,clear:true,afterState:'closed'}}));
    });
    root.addEventListener('orion:facets-updated',()=>{
      bindForm(); dirty=false;
      form.inert=state!=='open'||panel.dataset.facetsBusy==='true';
      if(state==='open') loadLimits();
      peek.querySelector('[data-filter-peek-count]').textContent=Number(panel.dataset.activeCount)||'';
      if(!Number(panel.dataset.activeCount)&&state==='peek') setState('closed',false);
    });
    bindForm();
    let stored='closed';try{stored=sessionStorage.getItem(memoryKey)||'closed';}catch(error){}
    opened=stored!=='closed';
    setState(stored==='peek' && mobile.matches && Number(panel.dataset.activeCount)>0?'peek':'closed',false);
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-collection-hover"] && !Shopify.designMode) return;
  try {
    (() => {
  const ROOTS = '[data-orion-gallery],[data-orion-catalog-cards],[data-orion-light-auto]';
  const CARD = '.orion-collection-page__card,[data-orion-light-card]';
  const MEDIA = '.orion-collection-page__card-media,[data-orion-light-media]';
  const initialize = () => document.querySelectorAll(ROOTS).forEach(root => {
    if (root.dataset.orionHoverReady) return;
    const template = root.querySelector('[data-orion-card-light-template]');
    if (!template || !Element.prototype.animate) return;
    root.dataset.orionHoverReady = 'true';
    const auto = root.hasAttribute('data-orion-light-auto');
    const fineHover = matchMedia('(any-hover:hover) and (any-pointer:fine)');
    // The owner's rule: this motion plays also when the system asks for reduced motion.
    const reduced = { matches: false };
    const records = new Map();
    let active = null;
    const transform = y => `translate3d(0,${y}px,0) scale(1.012)`;
    const cancel = animations => animations.forEach(animation => animation.cancel());
    // One timeline keeps the image and its separate alpha mask aligned at every frame.
    const together = (nodes,frames,timing) => {
      const animations = nodes.map(node => node.animate(frames,timing));
      const startTime = document.timeline.currentTime;
      if (startTime !== null) animations.forEach(animation => { animation.startTime = startTime; });
      return animations;
    };
    const move = (record,frames,timing) => {
      cancel(record.motions);
      record.motions = together([record.image,record.glow,record.sheen].filter(Boolean),frames,timing);
      return record.motions[0];
    };
    const fade = (record,frames,timing) => {
      cancel(record.fades);
      record.fades = together([record.light,record.glow,record.sheen].filter(Boolean),frames,timing);
    };
    // A layer on the picture's own box, which moves with the picture.
    const cover = (media,image,className) => {
      const layer = document.createElement('span');
      layer.className = className;
      layer.setAttribute('aria-hidden','true');
      const imageBox = image.getBoundingClientRect(), mediaBox = media.getBoundingClientRect();
      layer.style.left = `${imageBox.left-mediaBox.left-media.clientLeft}px`;
      layer.style.top = `${imageBox.top-mediaBox.top-media.clientTop}px`;
      layer.style.width = `${imageBox.width}px`;
      layer.style.height = `${imageBox.height}px`;
      layer.style.transformOrigin = getComputedStyle(image).transformOrigin;
      media.appendChild(layer);
      return layer;
    };
    const createSheen = (media,image) => {
      if (!CSS.supports('mask-image','linear-gradient(#000,#000)')) return null;
      const style = getComputedStyle(image);
      const sheen = cover(media,image,'orion-card-sheen');
      sheen.style.maskSize = ['contain','cover'].includes(style.objectFit) ? style.objectFit : '100% 100%';
      sheen.style.maskPosition = style.objectPosition;
      sheen.style.setProperty('--card-sheen-image',`url(${JSON.stringify(image.currentSrc || image.src)})`);
      const band = document.createElement('span');
      band.className = 'orion-card-sheen__band';
      sheen.appendChild(band);
      return sheen;
    };
    // A picture cut to its outline (the ATLAS photograph) loses its drop-shadow to the clip-path, so a blurred copy of
    // the outline glows behind it instead.
    const createGlow = (media,image) => {
      const clip = getComputedStyle(image).clipPath;
      if (!clip || clip === 'none') return null;
      const glow = cover(media,image,'orion-card-glow');
      const shape = document.createElement('span');
      shape.className = 'orion-card-glow__shape';
      shape.style.clipPath = clip;
      glow.appendChild(shape);
      return glow;
    };
    const destroy = record => {
      record.version += 1;
      cancel(record.motions);
      cancel(record.fades);
      cancel(record.effects);
      record.light.remove();
      record.glow?.remove();
      record.sheen?.remove();
      delete record.card.dataset.cardHoverActive;
      record.card.dataset.cardFloatState = 'idle';
      records.delete(record.card);
      if (active === record) active = null;
    };
    const stop = (record, immediate = false) => {
      if (!record) return;
      if (immediate || !record.card.isConnected) { destroy(record); return; }
      if (active === record) active = null;
      const version = ++record.version;
      const pose = getComputedStyle(record.image).transform;
      const opacity = getComputedStyle(record.light).opacity;
      record.card.dataset.cardHoverActive = 'false';
      record.card.dataset.cardFloatState = 'returning';
      fade(record,[{opacity},{opacity:0}],{duration:600,easing:'ease-out',fill:'forwards'});
      const departure = move(record,[{transform:pose},{transform:'none'}],{duration:600,easing:'cubic-bezier(.22,.7,.2,1)',fill:'forwards'});
      departure.finished.then(() => { if (record.version === version) destroy(record); }).catch(() => {});
    };
    const buildEffects = record => {
      const gentle = reduced.matches;
      const width = record.media.clientWidth, height = record.media.clientHeight;
      const lightDrift = gentle ? 2 : 4;
      record.effects.push(record.light.querySelector('.orion-card-light__halo').animate([
        {transform:`translate3d(0,${-lightDrift}px,0) scale(.98)`,opacity:.75},
        {transform:`translate3d(0,${lightDrift}px,0) scale(1.07)`,opacity:1},
        {transform:`translate3d(0,${-lightDrift}px,0) scale(.98)`,opacity:.75}
      ],{duration:6200,iterations:Infinity,easing:'ease-in-out'}));
      record.light.querySelectorAll('.orion-card-light__beam').forEach((beam,index) => {
        const angle = index*30, radians = angle*Math.PI/180;
        const drift = gentle ? 1.2 : 2.5;
        const x = 50+Math.sin(radians)*24, y = 46-Math.cos(radians)*6;
        const length = height*.42*Math.abs(Math.cos(radians))+width*.24*Math.abs(Math.sin(radians));
        beam.style.left = `${x-8}%`;
        beam.style.top = `calc(${y}% - ${length}px)`;
        beam.style.height = `${length}px`;
        const animation = beam.animate([
          {transform:`rotate(${angle-drift}deg) scaleY(.95)`,opacity:.55},
          {transform:`rotate(${angle+drift}deg) scaleY(1.05)`,opacity:.95},
          {transform:`rotate(${angle-drift}deg) scaleY(.95)`,opacity:.55}
        ],{duration:6000+(index%6)*240,iterations:Infinity,easing:'ease-in-out'});
        animation.currentTime = (index%6)*530;
        record.effects.push(animation);
      });
      if (record.sheen) record.effects.push(record.sheen.firstElementChild.animate([
        {transform:'translateX(-80%)',offset:0},
        {transform:'translateX(80%)',offset:.74},
        {transform:'translateX(80%)',offset:1}
      ],{duration:gentle?6500:5200,iterations:Infinity,easing:'ease-in-out'}));
    };
    // On hover one card lights at a time; always (the cart) every card lights and the pointer plays no part.
    const start = (card,always = false) => {
      if (!card || (!always && active?.card === card) || (always && records.has(card)) || document.hidden || root.dataset.filterOpen === 'true') return;
      const media = card.querySelector(MEDIA);
      const image = media?.querySelector(':scope > img');
      if (!image || !image.complete || !image.naturalWidth || card.classList.contains('is-gallery-loading')) return;
      if (!always && active) stop(active);
      let record = records.get(card);
      if (!record) {
        // The glow keeps to the picture's size: full in the catalogues, smaller around the cart's small pictures.
        media.style.setProperty('--card-light-scale',Math.max(.4,Math.min(1,media.clientHeight/240)).toFixed(3));
        const light = template.content.firstElementChild.cloneNode(true);
        media.appendChild(light);
        media.dataset.cardMotionMedia = '';
        image.dataset.cardMotionImage = '';
        const glow = createGlow(media,image);
        const sheen = createSheen(media,image);
        record = {card,media,image,light,glow,sheen,effects:[],motions:[],fades:[],version:0};
        records.set(card,record);
        buildEffects(record);
      }
      if (!always) active = record;
      const version = ++record.version;
      const pose = getComputedStyle(image).transform;
      const opacity = getComputedStyle(record.light).opacity;
      card.dataset.cardHoverActive = 'true';
      card.dataset.cardFloatState = 'lifting';
      // Small pictures (the cart) rise and drift in proportion, so the light never leaves their frame.
      const scale = Math.min(1,media.clientHeight/150);
      const lift = Math.round((reduced.matches ? 6 : 10)*scale), drift = Math.round((reduced.matches ? 5 : 7)*scale);
      fade(record,[{opacity},{opacity:1}],{duration:700,easing:'ease-out',fill:'forwards'});
      const entrance = move(record,[{transform:pose},{transform:transform(-lift)}],{duration:650,easing:'cubic-bezier(.22,.7,.2,1)',fill:'forwards'});
      entrance.finished.then(() => {
        if (record.version !== version || (!always && active !== record) || !card.isConnected) return;
        move(record,[
          {transform:transform(-lift)},{transform:transform(-lift-drift)},{transform:transform(-lift)}
        ],{duration:reduced.matches?4800:4300,iterations:Infinity,easing:'ease-in-out'});
        card.dataset.cardFloatState = 'floating';
      }).catch(() => {});
    };
    const cardAt = target => target instanceof Element ? target.closest(CARD) : null;
    const ALWAYS = '[data-orion-light-always]';
    const isAlways = card => Boolean(card && card.matches(ALWAYS));
    const startAlways = () => root.querySelectorAll(ALWAYS).forEach(card => start(card,true));
    if (auto) {
      // Always on: every card glows in a loop. Cards the cart redraws light up again, and the light is rebuilt when
      // the page size changes or the tab comes back into view.
      const startAll = () => root.querySelectorAll(CARD).forEach(card => start(card,true));
      const destroyAll = () => [...records.values()].forEach(destroy);
      root.addEventListener('load',event => {
        const card = cardAt(event.target);
        if (!card || !(event.target instanceof HTMLImageElement)) return;
        const record = records.get(card);
        if (record && event.target === record.image) destroy(record);
        start(card,true);
      },true);
      new MutationObserver(() => {
        [...records.values()].forEach(record => { if (!record.card.isConnected) destroy(record); });
        startAll();
      }).observe(root,{childList:true,subtree:true});
      let resizeTimer = 0;
      window.addEventListener('resize',() => { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => { destroyAll(); startAll(); },250); },{passive:true});
      document.addEventListener('visibilitychange',() => { if (document.hidden) destroyAll(); else startAll(); });
      document.addEventListener('shopify:section:unload',event => { if (event.target.contains(root)) destroyAll(); });
      startAll();
      return;
    }
    root.addEventListener('pointerover',event => {
      if (event.pointerType === 'touch' || !fineHover.matches) return;
      const card = cardAt(event.target);
      if (card && !isAlways(card) && !card.contains(event.relatedTarget)) start(card);
    });
    root.addEventListener('pointerout',event => {
      if (active?.card === cardAt(event.target) && !active.card.contains(event.relatedTarget)) stop(active);
    });
    root.addEventListener('focusin',event => {
      const card = cardAt(event.target);
      if (event.target.matches(':focus-visible') && !isAlways(card)) start(card);
    });
    root.addEventListener('focusout',event => {
      if (active?.card === cardAt(event.target) && !active.card.contains(event.relatedTarget)) stop(active);
    });
    // clear() puts out the hover light; clearAll() also the card that always glows (it lights again with startAlways).
    const clear = () => [...records.values()].forEach(record => { if (!isAlways(record.card)) stop(record,true); });
    const clearAll = () => [...records.values()].forEach(record => stop(record,true));
    root.addEventListener('orion:collection-results-before',clearAll);
    root.addEventListener('orion:filter-dismiss',clear);
    root.addEventListener('load',event => {
      const card = cardAt(event.target);
      const record = records.get(card);
      if (record && event.target === record.image) stop(record,true);
      if (isAlways(card)) start(card,true);
    },true);
    document.addEventListener('visibilitychange',() => { if (document.hidden) clearAll(); else startAlways(); });
    document.addEventListener('shopify:section:unload',event => { if (event.target.contains(root)) clearAll(); });
    window.addEventListener('blur',clear);
    let alwaysTimer = 0;
    window.addEventListener('resize',() => {
      clear();
      clearTimeout(alwaysTimer);
      alwaysTimer = setTimeout(() => {
        [...records.values()].forEach(record => { if (isAlways(record.card)) destroy(record); });
        startAlways();
      },250);
    },{passive:true});
    // The card that always glows lights as soon as its picture is in, and again after the gallery redraws its results.
    new MutationObserver(() => {
      [...records.values()].forEach(record => { if (!record.card.isConnected) destroy(record); });
      startAlways();
    }).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class','data-filter-open']});
    startAlways();
    window.addEventListener('scroll',() => {
      if (!active) return;
      const bounds = active.media.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > innerHeight) stop(active,true);
    },{passive:true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-collection-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-orion-selector]').forEach(nav => {
    if (nav.dataset.ready === 'true') return;
    nav.dataset.ready = 'true';
    // «Baby» rises in once its calligraphic letters are in, or after 2.5 s with whatever face there is.
    const title = nav.querySelector('[data-orion-selector-title]');
    if (title) {
      let shown = false;
      const reveal = () => { if (shown) return; shown = true; requestAnimationFrame(() => title.classList.add('is-ready')); };
      const face = getComputedStyle(title).getPropertyValue('--selector-title-font').split(',')[0].replace(/["']/g, '').trim();
      window.setTimeout(reveal, 2500);
      if (document.fonts && face) document.fonts.load(`1em "${face}"`).then(reveal, reveal); else reveal();
    }
    const scene = nav.querySelector('[data-orion-scene].is-active');
    const video = scene?.querySelector('video');
    if (!video) return;
    // Where the film would not play smoothly (a phone on an ordinary line, a slow line, robots; layout/theme.liquid sets
    // data-orion-opening by the homepage's rule) the banner keeps its picture and the film is never asked for. Elsewhere
    // it is asked for here, as the script starts (owner, 2026-10-05: speed).
    const filmWanted = document.documentElement.getAttribute('data-orion-opening') !== 'picture';
    // A banner's film may have a copy of its own for phones (the phone picture's framing).
    const filmSource = (matchMedia('(max-width: 749px)').matches && video.dataset.srcPhone) || video.dataset.src;
    if (filmWanted && !video.getAttribute('src') && filmSource) { video.preload = 'auto'; video.src = filmSource; }
    const backdrop = nav.querySelector('.orion-selector__backdrop');
    const outlines = [...nav.querySelectorAll('.orion-selector__option')];
    const gallery = nav.closest('[data-orion-gallery]');
    let pending = false, blocked = false, retries = 0, frame = 0, point;
    let lastTime = -1, stalledSamples = 0;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    nav.dataset.activeScene = scene.dataset.orionScene;
    const visible = () => {
      const r = nav.getBoundingClientRect();
      return gallery?.dataset.filtered !== 'true' && gallery?.dataset.bannerSwitch !== 'true' && nav.isConnected && !document.hidden && r.bottom > 0 && r.top < innerHeight;
    };
    const play = () => {
      nav.dataset.onScreen = String(visible());
      if (!filmWanted) return;
      if (!visible()) { video.pause(); return; }
      if (video.readyState >= 2) scene.classList.add('has-film');
      if (pending || !video.paused) return;
      pending = true;
      video.muted = true;
      Promise.resolve(video.play()).then(() => { blocked = false; }).catch(error => {
        if (error.name === 'NotAllowedError') blocked = true;
      }).finally(() => { pending = false; });
    };
    video.addEventListener('playing', () => { scene.classList.add('has-film'); blocked = false; retries = 0; });
    video.addEventListener('canplay', play);
    video.addEventListener('loadeddata', play);
    video.addEventListener('error', () => {
      scene.classList.remove('has-film');
      if (retries < 2 && visible()) {
        retries += 1;
        window.setTimeout(() => { if (nav.isConnected) { video.load(); play(); } }, 1200 * retries);
      } else { blocked = true; }
    });
    // The film has no pause: a browser that blocked autoplay starts it at the first touch or key.
    const interact = () => { if (video.paused) { blocked = false; play(); } };
    document.addEventListener('pointerdown', interact, {passive:true});
    document.addEventListener('keydown', interact);
    document.addEventListener('visibilitychange', play);
    window.addEventListener('pageshow', play);
    const observer = new IntersectionObserver(play, {threshold:[0,.05,.2]});
    observer.observe(nav);
    const watchdog = window.setInterval(() => {
      if (!nav.isConnected) {
        clearInterval(watchdog); observer.disconnect(); video.pause();
        document.removeEventListener('pointerdown', interact); document.removeEventListener('keydown', interact);
        document.removeEventListener('visibilitychange', play); window.removeEventListener('pageshow', play);
        gallery?.removeEventListener('orion:collection-banner',play);
        return;
      }
      if (!filmWanted || !visible() || blocked) { stalledSamples = 0; return; }
      if (video.paused) play();
      if (video.currentTime === lastTime) stalledSamples += 1; else stalledSamples = 0;
      lastTime = video.currentTime;
      if (stalledSamples >= 2 && retries < 2) { retries += 1; stalledSamples = 0; video.load(); play(); }
    }, 4000);
    const illuminate = () => {
      frame = 0;
      if (!point) return;
      const field = backdrop.getBoundingClientRect();
      nav.style.setProperty('--spotlight-on','1');
      nav.style.setProperty('--spotlight-x',`${point.x-field.left}px`);
      nav.style.setProperty('--spotlight-y',`${point.y-field.top}px`);
      outlines.forEach(outline => {
        const r=outline.getBoundingClientRect();
        const distance=Math.hypot(Math.max(r.left-point.x,0,point.x-r.right),Math.max(r.top-point.y,0,point.y-r.bottom));
        outline.style.setProperty('--proximity',String(Math.max(0,1-distance/90)));
      });
    };
    nav.addEventListener('pointermove', event => {
      if (event.pointerType === 'touch') return;
      point={x:event.clientX,y:event.clientY};
      if (!frame) frame=requestAnimationFrame(illuminate);
    },{passive:true});
    nav.addEventListener('pointerleave', () => {
      if (frame) cancelAnimationFrame(frame);
      frame=0; point=null;
      nav.style.setProperty('--spotlight-on','0');
      outlines.forEach(outline=>outline.style.setProperty('--proximity','0'));
    });
    nav.closest('[data-orion-gallery]')?.addEventListener('orion:collection-banner', play);
    play();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-sort-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    // Close an open sort menu on Escape or a click elsewhere, also after the catalogue has been redrawn.
    if (window.orionSortMenuReady) return;
    window.orionSortMenuReady = true;
    document.addEventListener('click', (event) => {
      document.querySelectorAll('details.orion-sort[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = event.target instanceof Element ? event.target.closest('details.orion-sort[open]') : null;
      if (!menu) return;
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
